










import useDefaultMeta from '@/composables/use-default-meta'
import useI18n from '@/composables/use-i18n'
import { computed, defineComponent, unref } from '@nuxtjs/composition-api'
import useCollectionContext, { parseTypeParams } from '@/composables/collection/use-collection-context'

export default defineComponent({
  head: {},
  layout: 'standard',
  asyncData ({ params, error }) {
    const type = parseTypeParams(params)

    if (!type) {
      error({ statusCode: 404 })
    }
  },
  setup () {
    const { type, query } = useCollectionContext()

    const i18n = useI18n()

    const title = String(i18n.t(`car.collection.${type.value}`))
    const bgClass = {
      [`bg-${type.value}`]: true,
    }
    const bgStyle = {
      backgroundImage: `url('https://cdn.gogoout.com/collection/${type.value}.jpg')`,
    }

    useDefaultMeta({
      title: computed(() => String(i18n.t('SEO.collection.title', [title]))),
      description: String(i18n.t('SEO.collection.metaDescription', [title])),
    })

    return {
      type,
      title,
      bgClass,
      bgStyle,
      query: unref(query),
    }
  },
})
